module.exports = __webpack_public_path__ + "static/media/light-grey.90ec5c5f.jpg";